export const FIREBASE_AUTH_ERROR_MESSAGES = {
  'auth/wrong-password': {
    text: 'The password is invalid or the user does not have a password.',
  },
  'auth/too-many-requests': {
    text: 'Access to {email} has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.',
  },
  'auth/claims-too-large': {
    text: 'The claims payload provided to setCustomUserClaims() exceeds the maximum allowed size of 1000 bytes.',
  },
  'auth/email-already-exists': {
    text: 'The provided email is already in use by an existing user. Each user must have a unique email.',
  },
  'auth/id-token-expired': {
    text: 'The provided Firebase ID token is expired.',
  },
  'auth/insufficient-permission': {
    text: 'The credential used to initialize the Admin SDK has insufficient permission to access the requested Authentication resource. Refer to Set up a Firebase project for documentation on how to generate a credential with appropriate permissions and use it to authenticate the Admin SDKs.',
  },
  'auth/internal-error': {
    text: 'The Authentication server encountered an unexpected error while trying to process the request. The error message should contain the response from the Authentication server containing additional information. If the error persists, please report the problem to our Bug Report support channel.',
  },
  'auth/invalid-continue-uri': {
    text: 'The continue URL must be a valid URL string.',
  },
  'auth/invalid-disabled-field': {
    text: 'The provided value for the disabled user property is invalid. It must be a boolean.',
  },
  'auth/invalid-display-name': {
    text: 'The provided value for the displayName user property is invalid. It must be a non-empty string.',
  },
  'auth/invalid-dynamic-link-domain': {
    text: 'The provided dynamic link domain is not configured or authorized for the current project.',
  },
  'auth/invalid-email': {
    text: 'Please enter a valid email address or password.',
  },
  'auth/invalid-email-verified': {
    text: 'The provided value for the emailVerified user property is invalid. It must be a boolean.',
  },
  'auth/invalid-password': {
    text: 'The provided value for the password user property is invalid. It must be a string with at least six characters.',
  },
  'auth/invalid-phone-number': {
    text: 'The provided value for the phoneNumber is invalid. It must be a non-empty string.',
  },
  'auth/invalid-photo-url': {
    text: 'The provided value for the photoURL user property is invalid. It must be a string URL.',
  },
  'auth/invalid-provider-data': {
    text: 'The providerData must be a valid array of UserInfo objects.',
  },
  'auth/invalid-provider-id': {
    text: 'The providerId must be a valid supported provider identifier string.',
  },
  'auth/invalid-uid': {
    text: 'The provided uid must be a non-empty string with at most 128 characters.',
  },
  'auth/invalid-user-import': {
    text: 'The user record to import is invalid.',
  },
  'auth/maximum-user-count-exceeded': {
    text: 'The maximum allowed number of users to import has been exceeded.',
  },
  'auth/missing-uid': {
    text: 'A uid identifier is required for the current operation.',
  },
  'auth/uid-already-exists': {
    text: 'The provided uid is already in use by an existing user. Each user must have a unique uid.',
  },
  'auth/user-not-found': {
    text: 'There is no existing user record corresponding to the provided identifier.',
  },
  'polls/not-authorized': {
    text: 'Not authorized to write content',
  },
  'polls/missing-orgId': {
    text: 'Org ID is required',
  },
  'polls/missing-eventId': {
    text: 'Event ID is required',
  },
  'polls/no-change-editable': {
    text: 'Poll editable cannot be changed',
  },
  'polls/invalid-type': {
    text: 'Poll type is not valid',
  },
  'polls/missing-title': {
    text: 'Title is required',
  },
  'polls/title-too-long': {
    text: 'Title is too long. Maximum length is 200 characters',
  },
  'polls/options-required': {
    text: 'Options are required',
  },
  'polls/too-few-options': {
    text: 'At least two options are required',
  },
  'polls/too-many-options': {
    text: 'At most four options are permitted',
  },
  'polls/option-type': {
    text: 'Options must be objects',
  },
  'polls/option-title-required': {
    text: 'Option title is required',
  },
  'polls/option-title-too-long': {
    text: 'Option title is too long. Maximum length is 200 characters',
  },
  'polls/invalid-duration': {
    text: 'Poll duration must be a positive number',
  },
  'polls/no-such-event': {
    text: 'Event does not exist',
  },
  'polls/event-wrong-org': {
    text: 'The event must belong to the provided organization',
  },
  'polls/no-such-poll': {
    text: 'Poll does not exist',
  },
  'polls/poll-wrong-org': {
    text: 'The poll must belong to the provided organization',
  },
  'polls/poll-wrong-event': {
    text: 'The poll must belong to the provided event',
  },
  'polls/poll-not-editable': {
    text: 'Poll can no longer be updated',
  },
  'polls/poll-is-not-running': {
    text: 'Poll is not running',
  },
  'polls/no-update-type': {
    text: 'Poll type cannot be changed',
  },
  'polls/unknown-error': {
    text: 'Poll could not be created',
  },
  'polls/unknown-launch-error': {
    text: 'Poll could not be launched',
  },
  'polls/missing-broadcast-id': {
    text: 'Broadcast ID is required',
  },
  'polls/no-such-broadcast': {
    text: 'Broadcast does not exist',
  },
  'polls/invalid-broadcast-type': {
    text: 'Broadcast is not live',
  },
  'polls/poll-already-running': {
    text: 'To start this poll you have to end the ongoing poll.',
  },
  'polls/unknown-end-error': {
    text: 'Poll could not be ended',
  },
  'permission-denied': {
    text: 'permission denied.',
  },
  'moderate/invalid-argument': {
    text: 'The message failed to be pinned because the broadcast has not fully loaded. Please try again in a few seconds.',
  },
};

export const EMAIL = {
  login: {
    subject: {
      text: 'Magic link Sign in - #{dateString}',
    },
    header: {
      text: 'So close',
    },
    text: {
      text: 'To sign in, simply click below.',
    },
    buttonText: {
      text: 'Sign in now',
    },
  },
  'reset-password': {
    subject: {
      text: 'Reset password',
    },
    header: {
      text: "Don't worry",
    },
    text: {
      text: 'To reset your password, click below.',
    },
    buttonText: {
      text: 'Reset password',
    },
  },
  welcome: {
    subject: {
      text: 'Invite to Video Commerce',
    },
    subjectOneToOneOnly: {
      text: 'Invite to Video Consultation',
    },
    header: {
      text: 'You’re in!',
    },
    invitationText: {
      text: '{actionUserName} invited you to join {organizationName}.',
    },
    dashboardSignInText: {
      text: 'Sign in to your Bam Hub',
    },
    signInButtonText: {
      text: 'Sign in now',
    },
    termsAndConditionsAltText: {
      text: 'Terms and conditions',
    },
    downloadAppHeader: {
      text: 'Download App',
    },
    goLiveText: {
      text: 'To go live and broadcast your shows.',
    },
    downloadAppText: {
      text: 'Download the app to go live and leverage the power of video commerce!',
    },
    openAppOnIOSAltText: {
      text: 'Open app on iOS',
    },
    openAppOnAndroidAltText: {
      text: 'Open app on Android',
    },
  },
  'verify-email': {
    subject: {
      text: 'Verify your email',
    },
    header: {
      text: 'Verify your email',
    },
    text: {
      text: 'To verify your email, click below.',
    },
    buttonText: {
      text: 'Verify email',
    },
  },
  'booking-common': {
    joinMeeting: {
      text: 'Join Meeting',
      description: 'Text on a button in an email. The button will take the user to a website for the meeting',
    },
    addToCalendar: {
      text: 'Add to Calendar',
      description: 'A header text in an email, shown above calendar icons for adding the event to the user`s calendar',
    },
    confirmationNumber: {
      text: 'Confirmation Number',
      description: 'A text that is shown just to the side of the confirmation number of a booking',
    },
    needToGetInTouch: {
      text: 'Need to get in touch with us?',
      description: 'A text that is shown at the end of an email, if the user needs to get in touch with the sender. The sender email address will be shown below',
    },
    manageBooking: {
      text: 'Manage Booking',
      description: 'Text on a button that will take the user to a website where they can see the booking, reschedule or cancel',
    },
    viewInDashboard: {
      text: 'View in Bambuser dashboard',
      description: 'A link text that will take the user to a backoffice website where they can view details about the booking',
    },
    customerLink: {
      text: 'Customer link',
      description: 'A link text. When clicked, the user will be taken to a website where their customer should go to join the meeting',
    },
  },
  'booking-shopper-confirmation': {
    subject: {
      text: 'Your booking is confirmed',
      description: 'The subject of an email that is sent to a shopper when their booking is confirmed',
    },
    title: {
      text: 'Booking confirmation',
      description: 'A header text in an email, shown above the booking details',
    },
    subtitle: {
      text: 'Thank you for your booking!',
      description: 'A text in an email, shown under the title. Usually a thank you message, or greeting.',
    },
    message: {
      text: 'Hi {shopperName}. Thank you for your booking. Please find your appointment details below.',
      description: 'A text in an email, shown under the subtitle. Usually a greeting with the customers name {shopperName}. Use that same variable in the translated text where the name should go.',
    },
    joiningInstructions: {
      text: 'Join the meeting through the following link\n {meetingUrl}',
      description: 'A descripting text to instruct the user to join the meeting by clicking on the given link. The "\\n" makes the meeting url go on the next line. This will be shown in the event in the user`s calendar',
    },
  },
  'booking-shopper-reminder': {
    subject: {
      text: 'Reminder: Your booking is coming up',
      description: 'The subject of an email that is sent to a shopper when their booking is coming up',
    },
    title: {
      text: 'Reminder of appointment',
      description: 'A header text in an email, shown above the booking details',
    },
    subtitle: {
      text: 'Your appointment starts soon',
      description: 'A text in an email, shown under the title. Some descriptive text of what this email is about. In this case a reminder that their appointment will start soon. "Soon" can in some cases be in 1 hour and in other cases tomorrow, so do not be too specific',
    },
    message: {
      text: 'This is a reminder of your appointment. Below is your details and meeting link',
      description: 'A descriptive text in email, shown under the subtitle and above the booking details',
    },
    joiningInstructions: {
      text: 'Join the meeting through the following link\n {meetingUrl}',
      description: 'A descripting text to instruct the user to join the meeting by clicking on the given link. The "\\n" makes the meeting url go on the next line. This will be shown in the event in the user`s calendar',
    },
  },
  'booking-shopper-rescheduled': {
    subject: {
      text: 'Your appointment has been rescheduled',
      description: 'The subject of an email that is sent to a shopper when their booking has been rescheduled',
    },
    title: {
      text: 'Appointment rescheduled',
      description: 'A header text in an email, shown above the booking details',
    },
    subtitle: {
      text: 'Your appointment has been rescheduled',
      description: 'A text in an email, shown under the title. Some descriptive text of what this email is about. In this case that their appointment has been rescheduled',
    },
    message: {
      text: 'You find your new appointment details below',
      description: 'A descriptive text in email for a rescheduled appointment. Shown under the subtitle and above the booking details',
    },
    joiningInstructions: {
      text: 'Join the meeting through the following link\n {meetingUrl}',
      description: 'A descripting text to instruct the user to join the meeting by clicking on the given link. The "\\n" makes the meeting url go on the next line. This will be shown in the event in the user`s calendar',
    },
  },
  'booking-shopper-cancellation': {
    subject: {
      text: 'Your appointment has been cancelled',
      description: 'The subject of an email that is sent to a shopper when their booking has been cancelled',
    },
    title: {
      text: 'Cancellation confirmation',
      description: 'A header text in an email, shown above the booking details',
    },
    subtitle: {
      text: 'Your appointment has been cancelled',
      description: 'A text in an email, shown under the title. Some descriptive text of what this email is about. In this case that their appointment has been cancelled',
    },
    bookAnotherAppointment: {
      text: 'Book another appointment',
      description: 'A link text in email about a cancelled appointment. When clicked the user will be taken to a website where they can book another appointment.',
    },
  },
  'booking-agent-confirmation': {
    subject: {
      text: 'You have been booked | {organizationName}',
      description: 'The subject of an email that is sent to a staff member when they have been booked for an appointment through their website. The {organizationName} is the name of the organization the booking was made with; keep it in the translated text.',
    },
    title: {
      text: 'New booking',
      description: 'A header text in an email, shown above the booking details',
    },
    subtitle: {
      text: 'You have been booked',
      description: 'A text in an email, shown under the title. Descriptive about what the email is about. In this case that the person have been assigned to host a meeting',
    },
    message: {
      text: 'Hi {resourceName}, you have been booked for a {serviceName} at {organizationName}',
      description: 'A text in an email, shown under the subtitle. Usually a greeting with the staff member name {resourceName}. Use that same variable in the translated text where the name should go. The {serviceName} is the name of the service that they should host. The {organizationName} is the name of the organization the booking was made with; keep it in the translated text.',
    },
    joiningInstructions: {
      text: 'Join the meeting through the following link \n{meetingUrl}\n\nCustomer meeting link:\n{customerMeetingLink}',
      description: 'A descripting text to instruct the user to join the meeting by clicking on the given link. The "\\n" makes the meeting url go on the next line. This will be shown in the event in the user`s calendar',
    },
    meetingTitle: {
      text: '{serviceName} with {shopperName}',
      description: 'The title of the event in the staff members calendar. The {serviceName} is the name of the service that they should host. The {shopperName} is the name of the person that they should host.',
    },
  },
  'booking-agent-cancellation': {
    subject: {
      text: 'Booking cancelled | {organizationName}',
      description: 'The subject of an email that is sent to a staff member when their booking has been cancelled. The {organizationName} is the name of the organization the booking was made with; keep it in the translated text.',
    },
    title: {
      text: 'Cancellation',
      description: 'A header text in an email, shown above the booking details',
    },
    subtitle: {
      text: 'A booking has been cancelled',
      description: 'A text in an email, shown under the title. Some descriptive text of what this email is about. In this case that their appointment has been cancelled',
    },
    message: {
      text: 'Hello {resourceName}, your booking at {organizationName} has been cancelled',
      description: 'A greeting text in an email where a booking has been cancelled that was assigned to the staff member {resourceName}. The {organizationName} is the name of the organization the booking was made with; keep it in the translated text.',
    },
  },
  'booking-agent-rescheduled': {
    subject: {
      text: 'Booking rescheduled | {organizationName}',
      description: 'The subject of an email that is sent to a staff member when their booking has been rescheduled. The {organizationName} is the name of the organization the booking was made with; keep it in the translated text.',
    },
    title: {
      text: 'Reschedule confirmation',
      description: 'A header text in an email, shown above the booking details',
    },
    subtitle: {
      text: 'Your appointment has been rescheduled',
      description: 'A text in an email, shown under the title. Some descriptive text of what this email is about. In this case that their appointment has been rescheduled',
    },
    message: {
      text: 'Hello {resourceName}, the following appointment at {organizationName} has been rescheduled',
      description: 'A descriptive text in email for a rescheduled appointment. Shown under the subtitle and above the booking details. The {organizationName} is the name of the organization the booking was made with; keep it in the translated text.',
    },
    newTimeHeader: {
      text: 'NEW TIME',
      description: 'A slim header text in email for a rescheduled appointment. Shown above the new time',
    },
    joiningInstructions: {
      text: 'Join the meeting through the following link \n{meetingUrl}\n\nCustomer meeting link:\n{customerMeetingLink}',
      description: 'A descripting text to instruct the user to join the meeting by clicking on the given link. The "\\n" makes the meeting url go on the next line. This will be shown in the event in the user`s calendar',
    },
    meetingTitle: {
      text: '{serviceName} with {shopperName}',
      description: 'The title of the event in the staff members calendar. The {serviceName} is the name of the service that they should host. The {shopperName} is the name of the person that they should host.',
    },
  },
};
